//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SocialSharing from 'vue-social-sharing'

export default {
	props: {
		url: {
			type: String,
			required: true
		},
		email_subject: {
			type: String,
			default: 'Check out this link!'
		},
		email_body: {
			type: String,
			default: 'Thought you might like this website, check out the link below.'
		},
		show_social: Boolean,
		show_media: {
			type: Boolean,
			default: true
		}
	},
	components: {
		SocialSharing
	},
	data () {
		return {}
	},
	methods: {
		print () {
			window.print()
		},
		download () {
			const articleId = document.getElementById('article-id-for-pdf');
			if (articleId.getAttribute('data-article') !== "") {
				return window.location.href = `?file=${articleId.getAttribute('data-article')}`;
			}
		},
		email () {
			const body = encodeURIComponent(`${this.email_body}\r\r${this.url}`)
			return window.location.href =
				`mailto:?subject=${encodeURIComponent(this.email_subject)}&body=${body}`
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/components/SocialShare.vue